import { type FunctionalComponent, h } from '@stencil/core';

export const OffsiteDummyBannerSkeleton: FunctionalComponent<{}> = () => (
  <div class="search-skeleton__wrapper">
    <div class="search-skeleton__block">
      <div class="desktop search-skeleton-container">
        <div class="search-skeleton__section">
          <div class="search-skeleton">
            <div class="search-skeleton__item"></div>
            <div class="search-skeleton__item"></div>
            <div class="search-skeleton__item"></div>
          </div>
        </div>
      </div>
      <div class="search-skeleton__image-placeholder"></div>
    </div>
  </div>
);
